import { Property } from "@stratify/shared";
import {
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  query,
  QuerySnapshot,
  updateDoc,
} from "firebase/firestore";
import { db } from "../../../config/firebase";

export const subscribeToProperties = (
  userId: string,
  onNext: (properties: Property[]) => void,
  onError?: (error: Error) => void
): (() => void) => {
  const propertiesRef = collection(db, "users", userId, "properties");
  const q = query(propertiesRef);

  return onSnapshot(
    q,
    (snapshot: QuerySnapshot) => {
      const properties = snapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      })) as Property[];
      onNext(properties);
    },
    onError
  );
};

export const updateProperty = async (
  userId: string,
  propertyId: string,
  updates: Partial<Property>
): Promise<void> => {
  const propertyRef = doc(db, "users", userId, "properties", propertyId);
  await updateDoc(propertyRef, updates);
};

export const deleteProperty = async (
  userId: string,
  propertyId: string
): Promise<void> => {
  const propertyRef = doc(db, "users", userId, "properties", propertyId);
  await deleteDoc(propertyRef);
};
